{
  "version": 1,
  "asset_id": "7b12b607-dfb5-4699-ad5e-ad838437351a",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/7b12b607-dfb5-4699-ad5e-ad838437351a/applied-black.jpeg",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/7b12b607-dfb5-4699-ad5e-ad838437351a/applied-black.jpeg",
  "original_filename": "applied-black.jpeg",
  "size": 1056062,
  "content_type": "image/jpeg",
  "created_at": "2026-08-02T15:18:29Z"
}
